"use strict";

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderTitle = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _useHeaderMenu = require("../useHeaderMenu");

var _helpers = require("../helpers");

var _UiComponents = require("./UiComponents");

var _Icons = require("./Icons");

var _core = require("@emotion/core");

var HeaderTitle = function HeaderTitle(_ref) {
  var children = _ref.children;

  var _ref2 = (0, _useHeaderMenu.useHeaderMenu)(),
      _ref3 = _slicedToArray(_ref2, 2),
      _ref3$ = _ref3[1],
      prev = _ref3$.prev,
      close = _ref3$.close;

  return (0, _core.jsx)(_UiComponents.Container.HeaderTitle, null, (0, _core.jsx)(_UiComponents.Container.BrandWrapper, null, (0, _core.jsx)(_UiComponents.Layout.Flex, {
    alignItems: "center",
    padding: 0,
    as: "button",
    "aria-label": "Return",
    onClick: (0, _helpers.preventDefaults)(prev)
  }, (0, _core.jsx)(_Icons.ArrowLeft, {
    "aria-hidden": true
  })), (0, _core.jsx)(_UiComponents.Layout.Flex, {
    alignItems: "center",
    padding: 0
  }, children), (0, _core.jsx)(_UiComponents.Toggle, {
    as: "button",
    "aria-label": "Close",
    onClick: (0, _helpers.preventDefaults)(close)
  }, (0, _core.jsx)(_Icons.Close, {
    "aria-hidden": true
  }))));
};

exports.HeaderTitle = HeaderTitle;
process.env.NODE_ENV !== "production" ? HeaderTitle.propTypes = {
  children: _propTypes.node
} : void 0;
HeaderTitle.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "HeaderTitle",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};